export default class Capture {
  /**
   * Create new capture and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  /**
   * @return {Date}
   */
  get createDateTimeUtc () {
    return this._createDateTimeUtc
  }

  /**
   * @param {string} value
   */
  set createDateTimeUtc (value) {
    this._createDateTimeUtc = new Date(value)
  }
}
